module.exports = __webpack_public_path__ + "media/images/mstile-150x150-4e180410eae173335f0ab36284b506c6.png";